module.exports = __webpack_public_path__ + "img/2.1688ec3e.jpg";